module.exports = __webpack_public_path__ + "img/thumb_34.6918544a.jpg";